import React from 'react';

import { IColumn } from '@xcritical/grid';

export const numberFormatter = (amount: number) => {
  const amountFormatted = new Intl.NumberFormat('en-EN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 10,
  }).format(amount);

  return <div title={amountFormatted}>{amountFormatted}</div>;
};

export const amountGridFormatter = (column: IColumn): IColumn => ({
  ...column,
  render: numberFormatter,
});

export const amountGridEmptyFormatter = (column: IColumn): IColumn => ({
  ...column,
  render: (amount?: number) => {
    if (amount === undefined) return '';

    return numberFormatter(amount);
  },
});
